import React from 'react';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/DEPRECATED/components/form/layout'. 'app/webpack/javascripts/shared/DEPRECATED/components/form/layout.js' implicitly has an 'any' type.
import { FormField } from 'shared/DEPRECATED/components/form/layout';
import { withLocalePrefix } from 'shared/utils/translation';
import { ContentContainer, ContentHeader, Required } from '../../components';
import Errors from '../../shared/errors';
import OfficesSelector from '../../shared/offices_selector';
import type { Office } from '../../shared/types';
import type { DataRetentionRuleInterface } from '../data_retention_rule';

type Props = {
  allOfficesPath: string;
  errors: Array<string>;
  rule: DataRetentionRuleInterface;
  offices: Array<Office>;
  onChange: any;
  onToggleAllOffices: any;
};

const t = withLocalePrefix('gdpr.data_retention_rules.view.edit.offices');

export default function RetentionOffices(props: Props) {
  const {
    allOfficesPath,
    errors,
    rule,
    offices,
    onChange,
    onToggleAllOffices,
  } = props;
  return (
    <ContentContainer data-provides="offices">
      <FormField error={<Errors errors={errors} />}>
        <ContentHeader>
          {t('header')}
          &nbsp;
          <Required />
        </ContentHeader>
        <OfficesSelector
          allOfficesPath={allOfficesPath}
          error={errors && errors.length > 0}
          offices={offices}
          rule={rule}
          onChangeSelectedOffices={(selectedOffices: Array<number>) =>
            onChange(selectedOffices)
          }
          onToggleAllOffices={onToggleAllOffices}
          short
        />
      </FormField>
    </ContentContainer>
  );
}
